namespace AgerLMS.LMS {
    export interface OrderRow {
        OrderId?: number;
        OrderGuid?: string;
        Price?: number;
        PaidPrice?: number;
        CargoPrice?: number;
        OrderState?: OrderStates;
        ConfirmDate?: string;
        ConfirmUserId?: number;
        DiscountId?: number;
        DistanceSalesAgreement?: string;
        CargoTrackingNumber?: string;
        CargoCompanyId?: number;
        CargoDate?: string;
        CargoUserId?: number;
        ProvinceId?: number;
        PaymentType?: OrderPaymentTypes;
        CustomerId?: number;
        ManuelOrder?: boolean;
        Installment?: number;
        BillingAddress?: string;
        ShippingAddress?: string;
        CargoId?: number;
        OrderItems?: OrderItemRow[];
        OrderItemNames?: string;
        CargoSend?: boolean;
        CargoSmsSend?: boolean;
        CargoEmailSend?: boolean;
        AddCargoPrice?: boolean;
        ItemCount?: number;
        Isthereaproduct?: YesNo;
        ProvinceName?: string;
        DiscountAmount?: number;
        DiscountCoupon?: string;
        CustomerName?: string;
        CustomerNameLower?: string;
        CustomerMobileNumber?: string;
        CustomerTcNo?: string;
        CustomerEmail?: string;
        ExistFilterCourseId?: number;
        ExistFilterProductId?: number;
        CargoName?: string;
        CargoTaxNumber?: string;
        InsertUserId?: number;
        InsertDate?: string;
        InsertUserDisplayName?: string;
    }

    export namespace OrderRow {
        export const idProperty = 'OrderId';
        export const nameProperty = 'OrderGuid';
        export const localTextPrefix = 'LMS.Order';
        export const deletePermission = '?';
        export const insertPermission = '?';
        export const readPermission = 'LMS:Order:Read';
        export const updatePermission = '?';

        export declare const enum Fields {
            OrderId = "OrderId",
            OrderGuid = "OrderGuid",
            Price = "Price",
            PaidPrice = "PaidPrice",
            CargoPrice = "CargoPrice",
            OrderState = "OrderState",
            ConfirmDate = "ConfirmDate",
            ConfirmUserId = "ConfirmUserId",
            DiscountId = "DiscountId",
            DistanceSalesAgreement = "DistanceSalesAgreement",
            CargoTrackingNumber = "CargoTrackingNumber",
            CargoCompanyId = "CargoCompanyId",
            CargoDate = "CargoDate",
            CargoUserId = "CargoUserId",
            ProvinceId = "ProvinceId",
            PaymentType = "PaymentType",
            CustomerId = "CustomerId",
            ManuelOrder = "ManuelOrder",
            Installment = "Installment",
            BillingAddress = "BillingAddress",
            ShippingAddress = "ShippingAddress",
            CargoId = "CargoId",
            OrderItems = "OrderItems",
            OrderItemNames = "OrderItemNames",
            CargoSend = "CargoSend",
            CargoSmsSend = "CargoSmsSend",
            CargoEmailSend = "CargoEmailSend",
            AddCargoPrice = "AddCargoPrice",
            ItemCount = "ItemCount",
            Isthereaproduct = "Isthereaproduct",
            ProvinceName = "ProvinceName",
            DiscountAmount = "DiscountAmount",
            DiscountCoupon = "DiscountCoupon",
            CustomerName = "CustomerName",
            CustomerNameLower = "CustomerNameLower",
            CustomerMobileNumber = "CustomerMobileNumber",
            CustomerTcNo = "CustomerTcNo",
            CustomerEmail = "CustomerEmail",
            ExistFilterCourseId = "ExistFilterCourseId",
            ExistFilterProductId = "ExistFilterProductId",
            CargoName = "CargoName",
            CargoTaxNumber = "CargoTaxNumber",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            InsertUserDisplayName = "InsertUserDisplayName"
        }
    }
}
